import React, { ReactNode } from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import {
  alpha,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemText,
  styled,
  Tooltip,
} from "@mui/material";

const StyledListItemButton = styled(ListItemButton)(({ theme }) => {
  return {
    flexGrow: 0,
    borderRadius: 8,
    gap: "1rem",
    "& .MuiListItemIcon-root": {
      minWidth: "auto",
      marginBlock: 4,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
    "&:hover, &.Mui-selected:hover": {
      backgroundColor: alpha(theme.palette.primary.dark, 0.5),
    },
  };
}) as typeof ListItemButton;

type Props = {
  text?: string;
  icon?: ReactNode;
  tooltip?: Omit<React.ComponentProps<typeof Tooltip>, "children"> | string | false;
  to?: string;
} & Omit<ListItemButtonProps, "selected">;

const NavItem: React.FC<Props> = ({ text, to, tooltip, icon, ...props }) => {
  const { pathname } = useLocation();

  return (
    <Tooltip
      title={typeof tooltip === "string" && tooltip}
      arrow={true}
      placement="right"
      {...(typeof tooltip === "object" && tooltip)}
    >
      <StyledListItemButton
        to={to}
        component={!!to ? Link : "button"}
        selected={!!to && !!matchPath(to + "/*", pathname)}
        {...props}
      >
        {icon && <ListItemIcon sx={{ color: "primary.contrastText" }}>{icon}</ListItemIcon>}
        {text && <ListItemText>{text}</ListItemText>}
      </StyledListItemButton>
    </Tooltip>
  );
};

export default NavItem;
